import { SVGInterface } from "../../interface";

const ActiveCommunity = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.5502 5.25C15.6502 5.25 16.5502 4.35 16.5502 3.25C16.5502 2.15 15.6502 1.25 14.5502 1.25C13.4502 1.25 12.5502 2.15 12.5502 3.25C12.5502 4.35 13.4502 5.25 14.5502 5.25ZM10.9502 19.15L11.9502 14.75L14.0502 16.75V22.75H16.0502V15.25L13.9502 13.25L14.5502 10.25C15.8502 11.75 17.8502 12.75 20.0502 12.75V10.75C18.1502 10.75 16.5502 9.75 15.7502 8.35L14.7502 6.75C14.3502 6.15 13.7502 5.75 13.0502 5.75C12.7502 5.75 12.5502 5.85 12.2502 5.85L7.0502 8.05V12.75H9.0502V9.35L10.8502 8.65L9.2502 16.75L4.3502 15.75L3.9502 17.75L10.9502 19.15Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default ActiveCommunity;
